export default "__VITE_ASSET__CdsCYPbV__"